import type { ReactNode } from "react";
import { useBalanceWeightSource } from "@/devices";
import { WeightCaptureContext } from "@/features/inventory/api";

/** Feeds the connected balance into every weight field (receiving check, stocktake) app-wide. */
export function BalanceCaptureProvider({ children }: { children: ReactNode }) {
  const source = useBalanceWeightSource();
  return <WeightCaptureContext.Provider value={source}>{children}</WeightCaptureContext.Provider>;
}
